import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SophisticatedFtueTooltip from '../../../Popover/Preset/SophisticatedFtueTooltip';
import { FirstTimeFlag } from '../../../redux/firstTimeFlags';

export interface Props {
  deviation: PapiDeviation;
  linkClassName?: string;
}

/** The tooltip that appears on mobile when the user views their
 *  first in-tier journal or lit. */
const SubscriptionLockLitFTUETooltip: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  linkClassName,
  children,
}) => {
  const { t } = useTranslation();
  const { subscriptionsTabUrl } = useSubscriptionTier(deviation);
  return (
    <SophisticatedFtueTooltip
      flag={FirstTimeFlag.IsMsLockedArtNotSeen}
      hasCloseButton
      size="medium"
      placement="top"
      heading={t('deviation.tier.subscribersOnly.tooltip.lockFtue.heading')}
      description={t('deviation.tier.subscribersOnly.tooltip.lockFtue.description')}
      postfix={
        <SophisticatedTooltipLink href={subscriptionsTabUrl} className={linkClassName}>
          {t('deviation.tier.subscribersOnly.tooltip.subscriptionsLink')}
        </SophisticatedTooltipLink>
      }
    >
      {children}
    </SophisticatedFtueTooltip>
  );
};
SubscriptionLockLitFTUETooltip.displayName = 'SubscriptionLockLitFTUETooltip';
export default SubscriptionLockLitFTUETooltip;
